// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceIntegration {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.createdAt = model.createdAt;
        this.type = model.type;
        this.workspaceId = model.workspaceId;
        this.integrationCredentials = model.integrationCredentials;
        this.integrationDesignSystems = model.integrationDesignSystems;
        this.state = (() => {
            const credentials = model.integrationCredentials;
            const anyActive = credentials === null || credentials === void 0 ? void 0 : credentials.some((c) => c.state === "Active");
            if (anyActive)
                return "Active";
            const anyPending = credentials === null || credentials === void 0 ? void 0 : credentials.some((c) => c.state === "Pending");
            if (anyPending)
                return "Pending";
            const anySuspended = credentials === null || credentials === void 0 ? void 0 : credentials.some((c) => c.state === "Suspended");
            if (anySuspended)
                return "Suspended";
            const anyInactive = credentials === null || credentials === void 0 ? void 0 : credentials.some((c) => c.state === "Inactive");
            if (anyInactive)
                return "Inactive";
            return undefined;
        })();
    }
}
export class WorkspaceIntegrations {
    get hasFigmaIntegration() {
        return this.integrations.some(({ type, integrationCredentials }) => type === "Figma" && Number(integrationCredentials === null || integrationCredentials === void 0 ? void 0 : integrationCredentials.length) > 0);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.integrations = model.integrations.map((i) => new WorkspaceIntegration(i));
    }
}
